export const LOADING_TECHNICAL_KNOWLEDGE = "LOADING_TECHNICAL_KNOWLEDGE";
export const SAVE_LOADING_TECHNICAL_KNOWLEDGE = "SAVE_LOADING_TECHNICAL_KNOWLEDGE";
export const GET_TECHNICAL_KNOWLEDGE = "GET_TECHNICAL_KNOWLEDGE";
export const FORM_FAIL = "FORM_FAIL";
export const FORM_FAIL_JSON = "FORM_FAIL_JSON";
export const TECHNICAL_KNOWLEDGE_FAIL = "TECHNICAL_KNOWLEDGE_FAIL";
export const LOADING_TECHNICAL_KNOWLEDGE_BY_ID = "LOADING_TECHNICAL_KNOWLEDGE_BY_ID";
export const GET_TECHNICAL_KNOWLEDGE_BY_ID = "GET_TECHNICAL_KNOWLEDGE_BY_ID";

